/*
 * TodoConstants
 */

import keyMirror from 'keymirror'

const EditAreaConstants = keyMirror({
  REPLACE_SEARCH_RESULTS: null,
  COPY_GLOSSARY_IN_EDIT_AREA: null,
  COPY_FRAGMENT_TO_CLIPBOARD: null,
  EDIT_AREA_CHANGED: null,
})

export default EditAreaConstants
